import { useMutation } from '@tanstack/react-query';

import { useSnackBar } from '@sbv-clients/ui-shared';
import { getApiErrorMessage } from '@sbv-clients/util-misc';

import {
  PunchRequestsV2ApiApiV2PunchRequestsPunchNotificationIdApprovePostRequest,
  PunchRequestsV2ApiApiV2PunchRequestsPunchNotificationIdRejectPostRequest,
  useApi,
} from '../index';
import { useInvalidatePunchCache } from './util/use-invalidate-punch-cache';

export const useApprovePunchRequest = () => {
  const api = useApi();
  const { notifyError } = useSnackBar();
  const updateCache = useInvalidatePunchCache();

  return useMutation(
    (
      requestParameters: PunchRequestsV2ApiApiV2PunchRequestsPunchNotificationIdApprovePostRequest
    ) =>
      api.punchRequestsV2Api.apiV2PunchRequestsPunchNotificationIdApprovePost(
        requestParameters
      ),
    {
      onSuccess: async () => {
        await updateCache();
      },
      onError: async (error) => {
        notifyError(getApiErrorMessage(error));
      },
    }
  );
};

export const useRejectPunchRequest = () => {
  const api = useApi();
  const { notifyError } = useSnackBar();
  const updateCache = useInvalidatePunchCache();

  return useMutation(
    (
      requestParameters: PunchRequestsV2ApiApiV2PunchRequestsPunchNotificationIdRejectPostRequest
    ) =>
      api.punchRequestsV2Api.apiV2PunchRequestsPunchNotificationIdRejectPost(
        requestParameters
      ),
    {
      onSuccess: async () => {
        await updateCache();
      },
      onError: async (error) => {
        notifyError(getApiErrorMessage(error));
      },
    }
  );
};
